import con from '../../../../connection';
var path = '/settings';
var settings = function (url) { return function (planId, applicationId) { return ({
    get: function () { return con.get(url + '/' + planId + '/' + applicationId + path, {}); },
    post: function (param) { return con.post(url + '/' + planId + '/' + applicationId + path, param); },
}); }; };
export default settings;
